var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuyCurrencyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6Zm6.29-.66h-.62a.326.326 0 0 1-.33-.329c0-.185.146-.33.33-.33h1.61a.66.66 0 0 0 .659-.659.661.661 0 0 0-.66-.66h-.62v-.659A.661.661 0 0 0 12 4.044a.661.661 0 0 0-.66.66v.659c0 .006.002.011.004.016.002.005.003.01.003.017a1.654 1.654 0 0 0-1.325 1.615c0 .91.738 1.648 1.648 1.648h.62c.185 0 .33.145.33.356 0 .185-.145.33-.33.33h-1.609a.661.661 0 0 0-.659.66c0 .369.297.659.66.659h.659v.633a.66.66 0 0 0 .659.659c.363 0 .66-.297.66-.66v-.672a1.662 1.662 0 0 0 1.278-1.635c0-.91-.738-1.648-1.648-1.648Zm8.673 8.97c.474-.383 1.177-.41 1.627 0a1.22 1.22 0 0 1-.05 1.867L16.767 22.8a2.447 2.447 0 0 1-1.528.534H1.611a.613.613 0 0 1-.611-.61v-3.667c0-.337.275-.612.611-.612h2.116l1.776-1.44A4.495 4.495 0 0 1 8.333 16h6.11c.745 0 1.334.665 1.208 1.428-.1.6-.665 1.016-1.272 1.016h-2.99a.613.613 0 0 0-.612.612c0 .336.275.61.611.61h4.518c.558 0 1.097-.186 1.528-.534l3.53-2.823Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyCurrencyIcon);
export default __webpack_public_path__ + "static/media/buy-currency-icon.f3761b2353bc1b16ab6968b4a12425ba.svg";
export { ForwardRef as ReactComponent };